import React, {useState, useEffect} from "react";
import {  useNavigate } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import FormContainer from "../components/FormContainer";
import CheckoutSteps from "../components/CheckoutSteps";
import Message from "../components/Message";
import { saveShippingAddress } from "../actions/cartActions";
import { useTranslation } from 'react-i18next';
import { BOOK_PRODUCT_ID, PRINT_PRODUCT_ID } from '../constants/productConfig';


function ShippingScreen() {
    const { t } = useTranslation();

    const cart = useSelector(state => state.cart);
    const { shippingAddress } = cart;

    const [naddress , setNaddress] = useState(shippingAddress.address || "");
    const [city, setCity] = useState(shippingAddress.city || "");
    const [postalCode, setPostalCode] = useState(shippingAddress.postalCode || "");
    const [country, setCountry] = useState(shippingAddress.country || "");
    const [phoneNumber, setPhoneNumber] = useState(shippingAddress.phoneNumber || "");
    const [message, setMessage] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const userLogin = useSelector(state => state.userLogin);
    const { userInfo } = userLogin;

    const [hasRedirected, setHasRedirected] = useState(false);

    const isPhysicalCartItem = (item) => (
      Number(item.product) === BOOK_PRODUCT_ID ||
      Number(item.product) === PRINT_PRODUCT_ID ||
      !item.is_digital
    );

    useEffect(() => {
        if (!userInfo) {
            navigate('/login?redirect=shipping');
        } else if (!hasRedirected && cart.cartItems) {
            // Skip shipping page if all items are digital
            const allDigital = cart.cartItems.length > 0 && 
                     cart.cartItems.every(item => !isPhysicalCartItem(item));
            if (allDigital) {
                setHasRedirected(true);
            navigate('/placeorder');
            }
        }
    }, [navigate, userInfo, hasRedirected, cart.cartItems]);

        useEffect(() => {
          if (!shippingAddress.phoneNumber && userInfo?.phone_number) {
            setPhoneNumber(userInfo.phone_number);
          }
        }, [shippingAddress.phoneNumber, userInfo?.phone_number]);


    function submitHandler(e) {
        e.preventDefault();
        if (!naddress || !city || !postalCode || !country || !phoneNumber) {
            setMessage(t('shipping.fillAllFields'));
        } else {
          dispatch(saveShippingAddress({ address: naddress, city, postalCode, country, phoneNumber }));
          navigate('/placeorder');
        }
    }

    
  return (
    <FormContainer>
        <CheckoutSteps step1 step2/>
      <h1>{t('shipping.title')}</h1>
      {message && <Message variant="danger">{message}</Message>}
      <Form onSubmit={submitHandler}>
        <Form.Group controlId="address">
          <Form.Label>{t('shipping.address')}</Form.Label>
          <Form.Control
            required
            type="text"
            placeholder={t('shipping.addressPlaceholder')}
            value={naddress ? naddress : ""}
            onChange={(e) => setNaddress(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId="city">
          <Form.Label>{t('shipping.city')}</Form.Label>
          <Form.Control
            required
            type="text"
            placeholder={t('shipping.cityPlaceholder')}
            value={city ? city : ""}
            onChange={(e) => setCity(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId="postalCode">
          <Form.Label>{t('shipping.postalCode')}</Form.Label>
          <Form.Control
            required
            type="text"
            placeholder={t('shipping.postalCodePlaceholder')}
            value={postalCode ? postalCode : ""}
            onChange={(e) => setPostalCode(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId="country">
          <Form.Label>{t('shipping.country')}</Form.Label>
          <Form.Control
            required
            type="text"
            placeholder={t('shipping.countryPlaceholder')}
            value={country ? country : ""}
            onChange={(e) => setCountry(e.target.value)}
          ></Form.Control>
        </Form.Group>

        <Form.Group controlId="phoneNumber">
          <Form.Label>{t('shipping.phone')}</Form.Label>
          <Form.Control
            required
            type="tel"
            placeholder={t('shipping.phonePlaceholder')}
            value={phoneNumber ? phoneNumber : ""}
            onChange={(e) => setPhoneNumber(e.target.value)}
          ></Form.Control>
        </Form.Group>




        <Button type="submit" variant="primary" className="mt-3">
          {t('shipping.submit')}
        </Button>
      </Form>  

    </FormContainer>
  );
}





export default ShippingScreen;